module.exports = __webpack_public_path__ + "static/media/suivi-healtheat.e18097d5.png";